import { css } from '@emotion/react';
import { Colors, Icon, Link, Typography } from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { useUniversalNavContext } from '../../../hooks/useUniversalNavContext';
import { emitUserInteractionEvent } from '../../../utils/avroEvents';
import { ArrowLinkIcon } from '../ArrowLinkIcon';
import { PRODUCT_LINKS } from '../constants';
const Styles = labelStyles('StaticProductRight', {
    root: css({
        display: 'flex',
        flexDirection: 'column',
        marginRight: 1,
        width: 250,
    }),
    header: css({
        display: 'flex',
        flexDirection: 'column',
        textDecoration: 'none',
        '&:hover [data-tag="heading"]': {
            color: Colors.zapier,
            textDecoration: 'none',
        },
        '&:hover [data-tag="subheading"]': {
            textDecoration: 'underline',
        },
        '&:hover [data-tag="arrow-icon-wrapper"]': {
            marginLeft: 4,
            opacity: 1,
        },
        '&:focus': {
            outline: `1px solid ${Colors.blueJeans}`,
        },
    }),
    heading: css(Object.assign(Object.assign({}, Typography.pageHeader9), { color: Colors.earth, lineHeight: '24px' })),
    subheading: css(Object.assign(Object.assign({}, Typography.smallPrint1), { color: Colors.neutral700, display: 'block', marginTop: 8 })),
    divider: css({
        margin: '16px 0',
        height: 1,
        backgroundColor: Colors.neutral300,
    }),
    linkContainer: css({
        display: 'flex',
        columnGap: 10,
        marginBottom: 8,
        textDecoration: 'none',
        color: Colors.earth,
        '&:hover [data-tag="link-heading"]': {
            color: Colors.zapier,
            textDecoration: 'none',
        },
        '&:hover [data-tag="link-icon"]': {
            color: Colors.zapier,
        },
        '&:hover [data-tag="tag-label"]': {
            textDecoration: 'none',
        },
        '&:hover [data-tag="link-description"]': {
            textDecoration: 'underline',
        },
        '&:hover [data-tag="arrow-icon-wrapper"]': {
            marginLeft: 4,
            opacity: 1,
            color: Colors.neutral700,
        },
        '&:focus': {
            outline: `1px solid ${Colors.blue}`,
        },
    }),
    linkIcon: css({
        marginTop: 6,
    }),
    linkTextContainer: css({
        display: 'flex',
        flexDirection: 'column',
    }),
    linkHeading: css(Object.assign(Object.assign({}, Typography.paragraph3Semibold), { marginRight: 6, lineHeight: '30px' })),
    linkHeadingRow: css({
        display: 'flex',
        alignItems: 'center',
    }),
    descriptionWrapper: css(Object.assign(Object.assign({}, Typography.smallPrint3), { lineHeight: '20px' })),
    linkDescription: css(Object.assign(Object.assign({}, Typography.smallPrint3), { color: Colors.neutral700, lineHeight: '20px' })),
    tagLabel: css(Object.assign(Object.assign({}, Typography.base), { fontSize: '10px', lineHeight: '14px', fontWeight: 600, padding: '2px 6px', borderRadius: 100, backgroundColor: Colors.lavender, textDecoration: 'none', textTransform: 'lowercase' })),
});
const earlyAccessLinks = [
    PRODUCT_LINKS.zapierTables,
    PRODUCT_LINKS.zapierInterfaces,
    PRODUCT_LINKS.aiChatbot,
];
const StaticProductRight = ({ onCloseMenu }) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const handleEvent = (text, eventType) => {
        emitUserInteractionEvent({
            event_action: eventType,
            option_selected: `Product tab Right: ${text}`,
        });
        if (eventType === 'click' && onCloseMenu)
            onCloseMenu();
    };
    return (isolateComponent("div", { css: Styles.root },
        isolateComponent(Link, { color: null, css: Styles.header, href: getFullyQualifiedURL(PRODUCT_LINKS.earlyAccessProgram.href), onClick: () => handleEvent('Early Access Program heading', 'click'), onMouseEnter: () => handleEvent('Early Access Program heading', 'hover') },
            isolateComponent("span", { css: Styles.heading, "data-tag": "heading" }, PRODUCT_LINKS.earlyAccessProgram.text),
            isolateComponent("div", null,
                isolateComponent("span", { css: Styles.subheading, "data-tag": "subheading" },
                    "Be the first to try new products",
                    isolateComponent(ArrowLinkIcon, null)))),
        isolateComponent("hr", { css: Styles.divider }),
        isolateComponent("ul", null, earlyAccessLinks.map((link) => (isolateComponent("li", { key: link.text },
            isolateComponent(Link, { color: null, css: Styles.linkContainer, href: getFullyQualifiedURL(link.href), onClick: () => handleEvent(link.text, 'click'), onMouseEnter: () => handleEvent(link.text, 'hover') },
                isolateComponent("span", { css: Styles.linkIcon, "data-tag": "link-icon" },
                    isolateComponent(Icon, { name: link.icon, size: 15 })),
                isolateComponent("div", { css: Styles.linkTextContainer },
                    isolateComponent("div", { css: Styles.linkHeadingRow },
                        isolateComponent("span", { css: Styles.linkHeading, "data-tag": "link-heading" }, link.text),
                        isolateComponent("span", { css: Styles.tagLabel, "data-tag": "tag-label" }, link.tag)),
                    isolateComponent("div", { css: Styles.descriptionWrapper },
                        isolateComponent("span", { css: Styles.linkDescription, "data-tag": "link-description" }, link.description),
                        isolateComponent(ArrowLinkIcon, null))))))))));
};
export default StaticProductRight;
//# sourceMappingURL=StaticProductRight.js.map
// @zapier/universal-layout@8.3.1 (41acce620)
